import { render, staticRenderFns } from "./ExibirColegiado.vue?vue&type=template&id=0b82ea61&scoped=true&"
import script from "./ExibirColegiado.vue?vue&type=script&lang=js&"
export * from "./ExibirColegiado.vue?vue&type=script&lang=js&"
import style0 from "./ExibirColegiado.vue?vue&type=style&index=0&id=0b82ea61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82ea61",
  null
  
)

export default component.exports